import { render, staticRenderFns } from "./Acquiring.vue?vue&type=template&id=107d02a2&scoped=true"
import script from "./Acquiring.vue?vue&type=script&lang=js"
export * from "./Acquiring.vue?vue&type=script&lang=js"
import style0 from "./Acquiring.vue?vue&type=style&index=0&id=107d02a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d02a2",
  null
  
)

export default component.exports